<template>
  <div class="w-100">
    <div class="d-flex justify-space-between">
      <div>
        <div class="w-100 text-grey-darken-2">
          <span v-for="(row, idx) in note.note.split('\n')" :key="idx">
            {{ row }} <br />
          </span>
        </div>
        <div
          class="mt-2 text-grey-darken-2 d-flex align-center justify-space-between gap-3">
          <span class="d-block">
            {{ new CustomDate(note.created_at).toString({ time: true }) }}
          </span>
          <slot name="showAllNotes"></slot>
        </div>
      </div>
      <v-btn
        v-if="!hideDelete"
        :disabled="!isAuthor"
        :loading="loading === note.id"
        icon
        size="x-small"
        variant="text"
        @click="$emit('delete', note.id)">
        <v-icon icon="mdi-delete-forever" size="small" />
      </v-btn>
    </div>
  </div>
</template>

<script>
import { useStore } from '@/plugins/index.js'
import { computed, inject } from 'vue'
import { CustomDate } from 'best-modules/utils'

export default {
  props: {
    note: { type: Object, required: true },
    loading: { type: [Number, Boolean] },
    hideDelete: { type: Boolean },
  },
  emits: ['delete'],
  methods: { CustomDate },

  setup(props) {
    const store = useStore()
    const loadingState = inject('loadingState', {})

    const userId = computed(() => store.state.user.userData?.id)
    const isAuthor = computed(() => {
      return props.note.userId === userId.value
    })

    return { loadingState, isAuthor }
  },
}
</script>

<style lang="scss"></style>
